import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ShareIcon } from "@t8891/icon";
import { postCommonShared } from "../../services/buyCarMenu";

const StyledItem = styled.div`
  display: flex;
  &:hover {
    #shareBlock {
      display: flex !important;
    }
  }
`;

export const FbAndLine: React.FC<{ link: string; className?: string; needHover?: boolean; id: number, objectType?: string, iconSize?: number }> = ({
  link,
  className = "flex gap-30",
  objectType = "buyCarMenu",
  iconSize = 46,
  needHover,
  id,
}) => {
  const handleClickUpDataShare = async (id) => {
    try {
      await postCommonShared({
        objectId: id,
        objectType: objectType,
      });
    } catch (error) {}
  };

  return (
    <div id={"FbAndLine"} className={className}>
      <div
        className={`w-${iconSize} h-${iconSize} cursor-pointer bg-no-repeat bg-[url(https://photo.8891.com.tw/2024/08/01/1722483352265514.png)]`}
        onClick={(e) => {
          e.preventDefault();
          handleClickUpDataShare(id);
          window.open(
            `https://www.facebook.com/share.php?u=${encodeURIComponent(link + "&s=fb")}`,
            "_blank",
            "width=670,height=500",
          );
        }}
        style={{
          backgroundSize: "100%",
        }}
      />
      <div
        className={`w-46 h-46 cursor-pointer bg-no-repeat bg-[url('https://photo.8891.com.tw/2024/08/01/1722483358105694.png')]`}
        onClick={(e) => {
          e.preventDefault();
          handleClickUpDataShare(id);
          window.open(
            `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(link + "&s=line")}`,
            "_blank",
            "width=670,height=500",
          );
        }}
        style={{
          backgroundSize: "100%",
        }}
      />
    </div>
  );
};

const ShareItem: React.FC<{ link: string; data: number; id: number }> = ({ link, data = 0, id }) => {
  return (
    <StyledItem>
      <div className='flex gap-4 items-center relative'>
        <div
          id='shareBlock'
          className='w-200 h-96 absolute bg-no-repeat bg-cover flex items-center justify-center z-1'
          style={{
            display: "none",
            left: "-90px",
            top: "-95px",
            backgroundImage: `url(https://photo.8891.com.tw/2024/08/05/1722851424668891.png)`,
          }}
        >
          <FbAndLine link={link} id={id} />
        </div>
        <ShareIcon size={20} fill='#333' className='cursor-pointer' />
        {!!data ? `${data}人分享` : "分享"}
      </div>
    </StyledItem>
  );
};
export default ShareItem;
